import { createTheme } from '@mui/material/styles';
import { ACCENT } from './styles/tokens';

// Same typography and surface treatment as Plankton CRM.
const FONT_FAMILY = ['Montserrat', '-apple-system', 'BlinkMacSystemFont', '"Segoe UI"', 'Roboto', '"Helvetica Neue"', 'Arial', 'sans-serif'].join(',');

const theme = createTheme({
    palette: {
        primary: { main: ACCENT, dark: '#356382', light: '#4e90b5', contrastText: '#fff' },
        background: { default: '#f8fafc' },
        text: { primary: '#1a2332', secondary: '#64748B' },
    },
    shape: { borderRadius: 10 },
    typography: {
        fontFamily: FONT_FAMILY,
        button: { textTransform: 'none', fontWeight: 600 },
    },
    components: {
        MuiPaper: {
            styleOverrides: {
                elevation1: { boxShadow: 'none', border: '1px solid #e8edf2' },
                elevation2: { boxShadow: 'none', border: '1px solid #e8edf2' },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: { borderRadius: 10 },
                containedPrimary: { boxShadow: '0 2px 8px rgba(66,120,152,0.22)' },
            },
        },
        MuiTableCell: {
            styleOverrides: { root: { borderBottom: '1px solid #f1f5f9' } },
        },
        MuiOutlinedInput: {
            styleOverrides: { root: { borderRadius: 10 } },
        },
    },
});

export default theme;
